import scrollFrame from "../main/setup/js/_scrollFrame.2";
import scrollWatch from "../main/setup/js/_scrollWatch.2";
$(document).on(
  "taydu2_cuuthienhuyennu_float_left rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    scrollFrame.init();
    scrollWatch.init({
      options: {
        onElementInView: function (e) {
          var $this = $(e.el).parents("[data-block-id]");
          var dataBlockId = $this.attr("data-block-id");
          $(
            `.nav-left--item[data-fts-selector='data-block-id="${dataBlockId}"']`
          );
          $(`[data-fts-selector='[data-block-id="${dataBlockId}"]']`).addClass(
            "active"
          );
          if (dataBlockId == "taydu2_cuuthienhuyennu_kimtuong") {
            $("#aside").addClass("active");
            $(".close").addClass("active");
          }
          // if (dataBlockId == "taydu2_cuuthienhuyennu_thatim") {
          //   $(".nav-left--item").removeClass("active");
          // }
        },
        onElementOutOfView: function (e) {
          var $this = $(e.el).parents("[data-block-id]");
          var dataBlockId = $this.attr("data-block-id");
          if (dataBlockId == "taydu2_cuuthienhuyennu_kimtuong") {
            $("#aside").removeClass("active");
            $(".close").removeClass("active");
          }
          $(
            `[data-fts-selector='[data-block-id="${dataBlockId}"]']`
          ).removeClass("active");
        },
      },
    });
  }
);
